import React, { Fragment } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";
import BookAnAppointmentBar from "../BookAnAppointmentBar.js";

export const Footer = ({ showBookAppointment = true } = {}) => {
  const data = useStaticQuery(graphql`
    query FooterOptions {
      wp {
        acfOptionsFooter {
          footerOptions {
            footerLogo {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            footerSocialIcons {
              label
              link
              svg
            }
            widget1Content
            widget1Title
            widget2Content
            widget2Title
            widget3Content
            widget3Title
            bookAnAppointment
          }
        }
      }
    }
  `);
  const footerDetails = data.wp.acfOptionsFooter.footerOptions;
  const footerSocialIcons = footerDetails.footerSocialIcons;
  const date = new Date();

  return (
    <Fragment>
      {showBookAppointment ? (
        <BookAnAppointmentBar
          title="Trusted diabetes care at"
          subTitle="Dr. Mohan’s Diabetes Specialities Centre"
          description="Book appointment with us today!"
          buttonText="Book Appointment"
          buttonLink={footerDetails.bookAnAppointment}
        />
      ) : null}
      <footer className="bg-footerbg py-12 lg:py-24">
        <div className="container mx-auto">
          <div className="flex flex-col justify-between lg:flex-row">
            <div className="flex-1 px-4">
              {data.wp.acfOptionsFooter.footerOptions.footerLogo && (
                <div className="mb-8">
                  <GatsbyImage
                    image={
                      data.wp.acfOptionsFooter.footerOptions.footerLogo
                        .localFile.childImageSharp.gatsbyImageData
                    }
                    alt=""
                  />
                </div>
              )}
              <div className="">
                <h3 className="mb-4 font-canossaBd text-2xl text-primary 2xl:text-4xl">
                  Follow Us For More Information
                </h3>
                <ul className="flex">
                  {footerSocialIcons.map((icon, index) => {
                    return (
                      <li key={index}>
                        <a
                          href={icon.link}
                          target="_blank"
                          rel="noreferrer"
                          className="mx-2 inline-block text-xl text-footericon 2xl:text-3xl"
                        >
                          {icon.svg === "FaFacebook" ? (
                            <FaFacebook />
                          ) : icon.svg === "FaLinkedin" ? (
                            <FaLinkedin />
                          ) : icon.svg === "FaInstagram" ? (
                            <FaInstagram />
                          ) : icon.svg === "FaYouTube" ? (
                            <FaYoutube />
                          ) : (
                            icon.svg === "FaXTwitter" && <FaXTwitter />
                          )}
                        </a>
                      </li>
                    );
                  })}{" "}
                </ul>
              </div>
            </div>
            <div className="flex-1 px-4">
              <h3 className="mb-4 mt-8 text-left font-canossaBd text-2xl font-bold text-primary  lg:mt-0 2xl:text-3xl">
                {footerDetails.widget1Title}
              </h3>
              <div
                className="text-left font-futuraMd text-lg text-black 2xl:text-xl"
                dangerouslySetInnerHTML={{
                  __html: footerDetails.widget1Content,
                }}
              ></div>
            </div>
            <div className="flex-1 px-4">
              <h3 className="mb-4 mt-8 text-left font-canossaBd text-2xl font-bold text-primary  lg:mt-0 2xl:text-3xl">
                {footerDetails.widget2Title}
              </h3>
              <div
                className="text-left font-futuraMd text-lg text-black 2xl:text-xl"
                dangerouslySetInnerHTML={{
                  __html: footerDetails.widget2Content,
                }}
              ></div>
            </div>
            <div className="flex-1 px-4">
              <h3 className="mb-4 mt-8 text-left font-canossaBd text-2xl font-bold text-primary  lg:mt-0 2xl:text-3xl">
                {footerDetails.widget3Title}
              </h3>
              <div
                className="text-left font-futuraMd text-lg text-black 2xl:text-xl"
                dangerouslySetInnerHTML={{
                  __html: footerDetails.widget3Content,
                }}
              ></div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="bg-primary py-2 text-center">
        <div className="container mx-auto font-futuraLt text-sm text-white opacity-50">
          Copyright &copy; {date.getFullYear()} - All Rights Reserved
        </div>
      </footer>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `window.ymConfig = { bot: "x1632898626254", host: "https://cloud.yellow.ai" };
(function () {
  var w = window,
    ic = w.YellowMessenger;

  if ("function" === typeof ic)
    ic("reattach_activator"), ic("update", ymConfig);
  else {
    var d = document,
      i = function () {
        i.c(arguments);
      };

    function l() {
      var e = d.createElement("script");

      (e.type = "text/javascript"),
        (e.async = !0),
        (e.src =
          "https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js");

      var t = d.getElementsByTagName("script")[0];

      t.parentNode.insertBefore(e, t);
    }

    (i.q = []),
      (i.c = function (e) {
        i.q.push(e);
      }),
      (w.YellowMessenger = i),
      w.attachEvent
        ? w.attachEvent("onload", l)
        : w.addEventListener("load", l, !1);
  }
})();`,
        }}
      ></script>
    </Fragment>
  );
};
